/**
 * eBay Success Page
 * @format
 */
import React from "react";

import { Images } from "@src/constants";

function SuccessScreen() {
  return (
    <section className="login">
      {/* <!-- patterns --> */}
      <div className="absolute-item one">
        <div className="circle"></div>
        <div className="circle two"></div>
      </div>
      <div className="absolute-item two">
        <div className="circle"></div>
        <div className="circle two"></div>
      </div>
      <div className="absolute-item three">
        <div className="circle"></div>
        <div className="circle two"></div>
      </div>
      <div className="absolute-item four">
        <div className="circle"></div>
        <div className="circle two"></div>
      </div>
      {/* <!-- illustration --> */}
      {/* <!-- navigation --> */}

      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          {/* <!-- logo --> */}
          <a className="navbar-brand" href="#">
            {" "}
            <img src={Images.logo} alt="" />{" "}
          </a>
        </div>
      </nav>
      <div className="container-fluid p-16vh redirect-sec">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-6 text-center text-md-start order-2 order-lg-1">
            <div className="login-title xl">
              <span style={{ color: "#217C78" }}> Successfully</span> Authorized
            </div>
            <div className="heading">You have successfully Authorized eBay</div>
          </div>
          <div className="col-lg-5 order-lg-2">
            <img
              src={Images.success}
              alt=""
              className="img-fluid redirect-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export { SuccessScreen };
